import authHeader from "../../../../authentication/authservices/auth-header";
import apiClient from "../../../../http-common";

export const saveGynacEMR = (obj) => {
  return apiClient.post(`/patientemr/saveEmrGynac`, obj, {
    headers: authHeader(),
  });
};

export const getPatientHistory = (PatientId, Department, unitId) => {
  return apiClient.get(
    `/patientemr/getPatientHistoryDepartmentWise/${PatientId}/${Department}/${unitId}`,
    {
      headers: authHeader(),
    }
  );
};

export  const getEDDDate = (obj) =>{
  return apiClient.post(
    `/patientemr/calculateGaEddByLmp`,obj,{
      headers: authHeader(),
    }
  )
}